<template>
  <card-item
    :isFull="true"
    card="item_subscription_log"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user['is_root'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "",
          key: "info",
          component: () => import("./Logs"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>